import { gql } from '@apollo/client';
import { EntityPermissionFieldsFragment, ErrorFragment } from '../fragments';
import {
  ScratchpadBasicFragment,
  ScratchpadWithNotesFragment,
  RichTextNoteFieldsFragment,
} from './fragments';
import {
  ImageEmbedFieldsFragment,
  PostUploadConfigFieldsFragment,
} from '../imageEmbed/fragments';

export const CREATE_SCRATCHPAD = gql`
  mutation CreateScratchpad($input: ScratchpadCreateInput!) {
    scratchpadCreate(input: $input) {
      entity {
        ...ScratchpadBasicFragment
      }
      errors {
        ...ErrorFields
      }
    }
  }
  ${ScratchpadBasicFragment}
  ${ErrorFragment}
`;

export const ADD_SCRATCHPAD_NOTE = gql`
  mutation AddScratchpadNote($input: ScratchpadNoteAddInput!) {
    scratchpadNoteAdd(input: $input) {
      entity {
        id
      }
      errors {
        ...ErrorFields
      }
    }
  }
  ${ErrorFragment}
`;

export const DELETE_SCRATCHPAD_NOTE = gql`
  mutation DeleteScratchpadNote($input: ScratchpadNoteDeleteInput!) {
    scratchpadNoteDelete(input: $input) {
      entity {
        id
      }
      errors {
        ...ErrorFields
      }
    }
  }
  ${ErrorFragment}
`;

export const MOVE_SCRATCHPAD_NOTE = gql`
  mutation MoveScratchpadNote($input: ScratchpadNoteMoveInput!) {
    scratchpadNoteMove(input: $input) {
      entity {
        id
      }
      errors {
        ...ErrorFields
      }
    }
  }
  ${ErrorFragment}
`;

export const EDIT_SCRATCHPAD = gql`
  mutation EditScratchpad($input: ScratchpadEditInput!) {
    scratchpadEdit(input: $input) {
      entity {
        id
      }
      errors {
        ...ErrorFields
      }
    }
  }
  ${ErrorFragment}
`;

export const EDIT_SCRATCHPAD_TEXT_NOTE = gql`
  mutation EditScratchpadTextNote($input: ScratchpadTextNoteEditInput!) {
    scratchpadTextNoteEdit(input: $input) {
      entity {
        ...RichTextNoteFields
      }
      errors {
        ...ErrorFields
      }
    }
  }
  ${RichTextNoteFieldsFragment}
  ${ErrorFragment}
`;

export const GET_SCRATCHPADS = gql`
  query GetScratchpads {
    scratchpads {
      entities {
        ...ScratchpadBasicFragment
      }
    }
  }
  ${ScratchpadBasicFragment}
`;

export const GET_SCRATCHPAD = gql`
  query GetScratchpad($id: ID!) {
    scratchpadGet(id: $id) {
      ...ScratchpadWithNotesFragment
    }
  }
  ${ScratchpadWithNotesFragment}
`;

export const DELETE_SCRATCHPAD = gql`
  mutation DeleteScratchpad($input: ScratchpadDeleteInput!) {
    scratchpadDelete(input: $input) {
      message
      errors {
        ...ErrorFields
      }
    }
  }
  ${ErrorFragment}
`;

export const VISIT_SCRATCHPAD = gql`
  mutation VisitScratchpad($input: ScratchpadVisitInput!) {
    scratchpadVisit(input: $input) {
      entity {
        ...ScratchpadBasicFragment
      }
      errors {
        ...ErrorFields
      }
    }
  }
  ${ScratchpadBasicFragment}
  ${ErrorFragment}
`;

export const SCRATCHPAD_EDIT_ENTITY_PERMISSIONS = gql`
  mutation scratchpadEntityPermissionEdit($input: EntityPermissionEditInput!) {
    entityPermissionEdit(input: $input) {
      entity {
        ...EntityPermissionFields
      }
      errors {
        ...ErrorFields
      }
    }
  }
  ${EntityPermissionFieldsFragment}
  ${ErrorFragment}
`;

export const CREATE_SCRATCHPAD_IMAGE_EMBED_UPLOAD_CONFIG = gql`
  mutation CreateScratchpadImageEmbedUploadConfig(
    $input: ScratchpadImageEmbedPostUploadConfigInput!
  ) {
    createScratchpadImageEmbedUploadConfig(input: $input) {
      imageEmbed {
        ...ImageEmbedFields
      }
      postUploadConfig {
        ...PostUploadConfigFields
      }
    }
  }
  ${ImageEmbedFieldsFragment}
  ${PostUploadConfigFieldsFragment}
`;
